import theme from "utils/themeVars"
import { Icon, Space } from ".."

const Feedback = ({ initialValue, meetingStatus, userID, allowFeedback, submitFeedback }) => {

  const handleLike = () => {
    let rating = initialValue === 5 ? 1 : 5
    submitFeedback({userId: userID, rating: rating }) 
  }

  const handleDislike = () => {
    let rating = initialValue === 3 ? 1 : 3
    submitFeedback({userId: userID, rating: rating }) 
  }

  return (
    <>
      <Space>
        <Icon
          icon="BiSolidLike"
          size="1.5em"
          color={initialValue === 5 ? theme["accent-color"] : theme["border-color-light"]}
          style={allowFeedback && { cursor: "pointer" }}
          onClick={e => {
            allowFeedback && meetingStatus === "in_progress" && handleLike()
          }}
        />
        <Icon
          icon="BiSolidDislike"
          size="1.5em"
          color={initialValue === 3 ? theme["accent-color"] : theme["border-color-light"]}
          style={allowFeedback && { cursor: "pointer" }}
          onClick={e => {
            allowFeedback && meetingStatus === "in_progress" && handleDislike()
          }}
        />
      </Space>
    </>
  )
}

export default Feedback
